import React, { useContext, useState } from "react";
import { ProjectContext } from "../utils/projectContext";
import { useNavigate } from "react-router-dom";
import menu from "../imgs/menu.png";
import title from "../imgs/title.png";
import Icon from "@mui/material/Icon";
import useAuthStore from "../store/auth";
import { Popover, message } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import action from "../icons/action.png";

const Title = ({ setShowOptions, showOptions, setShowCreate, type, fetchProjectList }) => {
  const { setSave } = useContext(ProjectContext);
  const { projectArr, setProjectArr } = useContext(ProjectContext);
  const { setProjectNow } = useContext(ProjectContext);
  const { setChangeName } = useContext(ProjectContext);
  const { showCloudCity, setShowCloudCity } = useContext(ProjectContext);
  const { setShouldDownloadJson } = useContext(ProjectContext);
  const { setSaveCallback } = useContext(ProjectContext);
  const [left, setLeft] = useState(0);
  const [top, setTop] = useState(0);
  const navigate = useNavigate();

  const { userInfo, setUserInfo } = useAuthStore();

  const pStyle = {
    fontSize: "28px",
    lineHeight: "90px",
  };

  const marginStyle = {
    margin: "0 0 0 10px",
    cursor: "pointer",
  };

  const saveAsJson = () => {
    setSave(true);
  };

  const openFile = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".json";
    input.onchange = (e) => {
      const file = e.target.files[0];
      const name = file.name.split(".")[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        let newProjectArr = [...projectArr];
        let newProject = JSON.parse(e.target.result);
        newProject.name = name;
        newProject.canvasStyle = {
          background: newProject.objects[0].fill,
          width: newProject.objects[0].width,
          height: newProject.objects[0].height,
          unit: "px",
          file: true,
        };
        newProjectArr.push(newProject);
        setProjectArr(newProjectArr);
        setProjectNow(newProjectArr[newProjectArr.length - 1]);
        navigate(`/${newProjectArr[newProjectArr.length - 1].name}`);
      };
      reader.readAsText(file);
    };
    input.click();
  };

  const clickProject = (e) => {
    setLeft(e.clientX);
    setTop(e.clientY);
    setChangeName(true);
    setShowOptions(!showOptions);
  };
  const goManual = () => {
    window.open(
      "https://g06o7xylva3.feishu.cn/docx/M4dQdH8saoenDTx1w4Ac07i0nNe"
    );
  };

  const signOut = () => {
    setUserInfo(null);
    message.success("退出成功");
    localStorage.clear();
    sessionStorage.clear(); // 清除sessionStorage中的用户信息
    
    // 重置项目相关状态
    setProjectArr([]);
    setProjectNow({});
    setChangeName(false);
    
    navigate("/");
  };

  const goMine = () => {
    navigate("/mine");
  }

  // 跳转3D场景
  const goThreeScene = async () => {
    setShouldDownloadJson(false); // 预览时不下载JSON文件
    
    // 先触发 saveCanvas 保存本地缓存
    setChangeName(true);
    
    // 设置保存完成后的回调
    setSaveCallback(() => async () => {
      try {
        // 上传完成后，重新获取项目列表以更新 localStorage
        if (fetchProjectList) {
          await fetchProjectList({ search: "" });
        }
        
        // 等待一小段时间确保 localStorage 写入完成
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // 验证 localStorage 数据
        const projectList = localStorage.getItem("projectList");
        if (!projectList) {
          console.error("localStorage 中没有 projectList 数据");
          message.error("数据加载失败，请重试");
          return;
        }
        // 显示3D场景
        setShowCloudCity(true);
        setSaveCallback(null); // 清除回调
      } catch (error) {
        console.error("更新项目数据失败:", error);
        message.error("数据加载失败，请重试");
      }
    });
    
    // 延迟一下确保 saveCanvas 执行完毕
    setTimeout(() => {
      saveAsJson();
    }, 100);
  }

  // 返回编辑
  const goEdit = () => {
    setShowCloudCity(false);
  }

  return (
    <div className="title">
      <div className="menu" style={{ pointerEvents: type === 'mine' ? 'none' : 'auto' }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={title} alt="" onClick={(e) => clickProject(e)} />
        {window.location.pathname !== "/home" && !showCloudCity && (
          <div
            style={{ marginLeft: 20, cursor: "pointer", color: "#1890ff" }}
            onClick={() => {navigate("/home");window.location.reload();}}
          >
            返回首页
          </div>
        )}
        {showCloudCity && (
          <div
            style={{ marginLeft: 20, cursor: "pointer", color: "#1890ff" }}
            onClick={goEdit}
          >
            返回编辑
          </div>
        )}
        </div>
        {showOptions && !showCloudCity && (
          <div
            className="options"
            style={{ left: left, top: top }}
            onClick={() => setShowOptions(false)}
          >
            <p onClick={() => setShowCreate(true)}>创建项目</p>
            <p onClick={openFile}>打开项目</p>
            <p onClick={() => saveAsJson()}>保存为JSON</p>
          </div>
        )}
      </div>
      {/* <h1>LIBRA</h1> */}
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        {
          (window.location.pathname !== '/home' && type !== 'mine' && type !== 'threeScene' && !showCloudCity) && (
            // <EyeOutlined style={{ marginRight: 20, cursor: "pointer" }} onClick={goThreeScene} />
            <img src={action} alt="" style={{ marginRight: 20, cursor: "pointer",width: '30px',height: '30px' }} onClick={goThreeScene} />
          )
        }
        {
          type === 'mine' && <div style={{ marginRight: 20, cursor: "pointer" }} onClick={() => navigate('/home')}>返回项目</div>
        }
        {!!userInfo && !showCloudCity && (
          <Popover
            content={
              <div>
                <div style={{ cursor: "pointer",lineHeight:'30px' }} onClick={goMine}>个人中心</div>
                <div onClick={signOut} style={{ cursor: "pointer",lineHeight:'30px'  }}>
                  退出登录
                </div>
              </div>
            }
            align="bottom"
            trigger="click"
          >
            <div style={{ cursor: "pointer", marginRight: "20px" }} onClick={()=>setChangeName(true)}>
              {userInfo.user.nickname}
            </div>
          </Popover>
        )}
        <Icon style={{ cursor: "pointer" }}>auto_stories</Icon>
        <p style={{ marginRight: 20, cursor: "pointer" }} onClick={goManual}>
          用户手册
        </p>
      </div>
    </div>
  );
};

export default Title;
